<template>
  <div class="custom-option-group" v-if="fullList.length && !option.off" :aria-label="$updateLang()">
    <div class="custom-label">{{ $dynamic(option, option.name, 'name') }}</div>

    <!-- <div class="custom-option-list" :class="{ 'if-single': fullList.length === 1 }">
      <div class="custom-option-checkbox check-image-full" v-for="(item, key) in fullList" :key="key"
        :class="{ 'disabled': item.disabled }">
        <input :id="'opt' + option_key + key" type="checkbox" :value="item" @change="event => onSelect(event, item)"
          :checked="isSelected(item)" :disabled="item.disabled">
        <label :for="'opt' + option_key + key">
          <span class="pick" v-if="item.image" :style="getImage(item)"></span>
          <span class="pick" v-else-if="item.color" :style="getColor(item)"></span>
          <span class="text">
            <span class="custom-option-name" v-if="item.name">{{ $dynamic(item, item.name, 'name') }}</span>
            <span class="custom-option-price">
              <span class="price" v-if="item.price" :class="{ 'was-selled': !!item.price_old }">
                {{ $filters.money(item.price) }} {{ $store.getters.getSettings.symbol }} </span>
              <span class="price price-old" v-if="item.price_old">
                {{ $filters.money(item.price_old) }} {{ $store.getters.getSettings.symbol }}
              </span>
            </span>
          </span>
        </label>
      </div>
    </div> -->


    <div v-if="fullList.length <= 4" class="custom-option-list" :class="{ 'if-single': fullList.length === 1 }">
      <div class="custom-option-checkbox check-image-full" v-for="(item, key) in fullList" :key="key">
        <input :id="'opt' + option_key + key" type="checkbox" :value="item" @change="event => onSelect(event, item)"
          :checked="isSelected(item)" :disabled="isSelectedDisable(item)">
        <label :for="'opt' + option_key + key">
          <span class="pick" v-if="item.image" :style="getImage(item)"></span>
          <span class="pick" v-else-if="item.color" :style="getColor(item)"></span>
          <span class="text">
            <span class="custom-option-name" v-if="item.name">{{ $dynamic(item, item.name, 'name') }}</span>
            <span class="custom-option-price">
              <span class="price" v-if="item.price" :class="{ 'was-selled': !!item.price_old }"> {{
                $filters.money(item.price) }} {{ $store.getters.getSettings.symbol }}</span>
              <span class="price price-old" v-if="item.price_old"> {{ $filters.money(item.price_old) }} {{
                $store.getters.getSettings.symbol }}</span>
            </span>
          </span>
        </label>
      </div>
    </div>

    <div v-else class="v-select-wrapper">
      <v-select :options="fullList" v-model="selected" @option:selected="(e) => { onVSelect(e, true) }"
        @option:deselected="(e) => { onVSelect(e, false) }" @open="isDropdownOpen = true"
        @close="isDropdownOpen = false" multiple class="option-select" :filterable="false" :searchable="false">
        <template v-slot:option="item">
          <!-- ? эта часть представляет собой плашку опции. Она требует стилизации -->
          <label class="option-in-select-row" :for="'opt' + option_key + key">
            <span class="option-in-select-image" v-if="item.image" :style="getImage(item)"></span>
            <span class="option-in-select-image" v-else-if="item.color" :style="getColor(item)"></span>
            <span class="option-in-select-name" v-if="item.name">{{ $dynamic(item, item.name, 'name') }}</span>
            <span class="option-in-select-price-container">
              <span class="option-in-select-price" v-if="item.price" :class="{ 'was-selled': !!item.price_old }">
                {{ $filters.money(item.price) }} {{ $store.getters.getSettings.symbol }}
              </span>
              <span class="option-in-select-price-old" v-if="item.price_old">
                {{ $filters.money(item.price_old) }} {{ $store.getters.getSettings.symbol }}
              </span>
            </span>
          </label>
          <!-- ?________________________________________________ -->
        </template>
      </v-select>

      <!-- Кастомный плейсхолдер -->
      <div v-if="!isDropdownOpen" class="custom-label custom-placeholder">
        {{ $static('item.option-choose', 'Обрати') }}
      </div>


      <div v-if="selected.length > 0" class=" custom-option-list custom-option-list__no-maxheight"
        :class="{ 'if-single': fullList.length === 1 }">
        <div class="custom-option-checkbox check-image-full" v-for="(item, key) in selected" :key="key">

          <button type="button" class="unselect-option-btn" @click="event => removeFromSelected(event, item)">
            <img src="/images/icons/close.svg" alt="">
          </button>

          <input :id="'opt' + option_key + key" type="checkbox" :value="item" checked :disabled="false">
          <label class="no-pointer-label" :for="'opt' + option_key + key">
            <span class="pick" v-if="item.image" :style="getImage(item)"></span>
            <span class="pick" v-else-if="item.color" :style="getColor(item)"></span>
            <span class="text">
              <span class="custom-option-name" v-if="item.name">{{ $dynamic(item, item.name, 'name') }}</span>
              <span class="custom-option-price">
                <span class="price" v-if="item.price" :class="{ 'was-selled': !!item.price_old }"> {{
                  $filters.money(item.price) }} {{ $store.getters.getSettings.symbol }}</span>
                <span class="price price-old" v-if="item.price_old"> {{ $filters.money(item.price_old) }} {{
                  $store.getters.getSettings.symbol }}</span>
              </span>
            </span>
          </label>
        </div>
      </div>

      <template v-else>
        <div v-if="option.req"
          class="no-options-selected-text  no-options-selected-text__required no-options-selected-text__required">
          Вибір цього типу опцій є обов'язковим
        </div>
        <div v-else class="no-options-selected-text">Опції не обрані
        </div>
      </template>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ItemUniqueOption',
  props: ['option', 'option_key'],
  emits: ['select'],

  data() {
    return {
      open: false,
      last: undefined,
      selected: [],
      isDropdownOpen: false,

    }
  },

  mounted() {
    if (!this.option.off && this.option.req && this.fullList.length) {
      if (this.fullList.length <= 4) {
        this.onSelect(true, this.fullList[0])
      } else {
        // this.selected.push(this.fullList[0]);
        // this.onVSelect(this.fullList[0], true)
      }
    }
  },

  methods: {
    isSelected(item) {
      return this.selected.findIndex(i => item._id === i._id) > -1
    },
    isSelectedDisable(item) {
      return this.isSelected(item) && this.disabled
    },
    getImage(item) {
      return `background-image: ${this.$filters.getItemImage(item.image)};`
    },
    getColor(item) {
      return `background-color: ${item.color};`
    },
    onSelect(event, item) {
      // console.log(item, this.last, event)
      // if (this.option.req && item === this.last){
      //   event.stopPropagation()
      //   event.preventDefault()
      //   this.last = item
      //   return
      // }
      let status = event
      if (event.target) {
        status = event.target.checked
      }
      if (status === false && this.option.req && this.selected.length - 1 < 1) {
        event.stopPropagation()
        event.preventDefault()
        event.target.checked = !status
        return false
      }
      if (this.option.single) {
        if (this.last) {
          this.$emit('select', { key: this.option_key, item: this.last, status: false })
        }
        let x = this.selected.findIndex(i => this.last._id === i._id)
        if (x > -1) {
          this.selected.splice(x, 1)
        }
      }
      this.last = item

      if (status) {
        this.selected.push(item)
      } else {
        let x = this.selected.findIndex(i => item._id === i._id)
        if (x > -1) {
          this.selected.splice(x, 1)
        }
      }
      this.$emit('select', { key: this.option_key, item: item, status: status })
    },

    onVSelect(optionData, status) {
      let selectedOption = undefined;


      if (Array.isArray(optionData)) {
        selectedOption = optionData[optionData.length - 1]
      } else {
        selectedOption = optionData
      }

      //Удаляем выбранную ранее опцию, если параметр единичного выбора включен
      if (this.option.single && this.selected[0]._id !== selectedOption._id) {
        this.$emit('select', { key: this.option_key, item: this.selected[0], status: false })
        this.selected.splice(0, 1);
      }

      this.$emit('select', { key: this.option_key, item: selectedOption, status: status })
    },

    removeFromSelected(event, item) {
      if (this.option.req && this.selected.length - 1 < 1) {
        return
      }

      const index = this.selected.findIndex(selectedItem => selectedItem._id === item._id);
      if (index !== -1) {
        this.selected.splice(index, 1);
        this.onSelect(event, item)
      }
    }
  },

  computed: {
    disabled() {
      return this.option.single ? this.option.req : this.option.req && this.selected.length === 1
    },
    allSettings() {
      return this.$store.getters.getSettings
    },
    // set() {
    //   return this.settings ? this.settings.find(x => x.option_id === this.option_key) : {}
    // },
    options_list() {
      return this.$store.getters.getOptions
    },
    info() {
      return this.option_key && this.options_list ? this.options_list[this.option_key] : undefined
    },
    fullList() {
      return this.option.list ? this.option.list : []
    }
  }
}
</script>

<style>
.disabled {
  cursor: crosshair;
  opacity: 0.6;
}

.disabled label {
  border: none;
}

.custom-option-list:before {
  z-index: 1;
  content: "";
  display: none;
  width: 100%;
  left: 0;
  position: absolute;
  bottom: 0;
  height: 35px;
  background: linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  background: -webkit-linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}

.custom-option-list {
  max-height: 139px;
  overflow: hidden;
  position: relative;
}

.custom-option-list__no-maxheight {
  max-height: none;
}

input[type='checkbox'].show-more:checked+div:before {
  display: none;
}

input[type='checkbox'].show-more:checked+div {
  max-height: inherit;
}

@media (min-width : 768px) {
  .custom-option-list {
    max-height: 139px;
  }

  .custom-option-list__no-maxheight {
    max-height: none;
  }
}

@media (min-width : 1200px) {
  .custom-option-list {
    max-height: 139px;
  }

  .custom-option-list__no-maxheight {
    max-height: none;
  }
}

.option-select {
  position: relative;
}

.v-select-wrapper {
  position: relative;
}

.unselect-option-btn {
  position: absolute;
  right: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 2px solid #dfe0e2;
  z-index: 1;
  cursor: pointer;

  &:hover {
    border-color: #39a0f7;
  }
}

.custom-placeholder {
  position: absolute;
  top: 12px;
  /* left: 10px; */
  margin: 4px 0 0;
  padding: 0 7px;
  transform: translateY(-50%);
  color: var(--vs-search-input-color);
  pointer-events: none;
  /* Чтобы плейсхолдер не перехватывал клики */
  z-index: 1;
}

.no-options-selected-text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4px;
  padding: 10px;
  border-radius: 6px;
  border: 2px solid #dfe0e2;

  &.no-options-selected-text__required {
    color: red;
  }
}

.vs__dropdown-toggle {
  margin-top: 4px;
  height: 30px !important;
}

.vs__selected-options {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;

  white-space: nowrap;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;
}

.v-select.vs--open .vs__selected-options {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  border: none;
  padding: 0;
  white-space: normal;
  clip-path: none;
  clip: auto;
  overflow: visible;
}

.vs__selected {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;

  white-space: nowrap;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;
}

.no-pointer-label {
  cursor: auto !important;
}

.option-in-select-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 4px;
  margin: 0;
  cursor: pointer;
}

.option-in-select-image {
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  margin-right: 4px;
  border-radius: 5px;
  background-color: red;
  background-size: cover;
}

.option-in-select-name {
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.option-in-select-price-container {
  margin-left: auto;
  display: flex;
  column-gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}

.option-in-select-price-old {
  text-decoration: line-through;
  font-size: 13px;
}

.vs__dropdown-menu {
  max-height: 200px !important;
  overflow-y: scroll !important;

  &::-webkit-scrollbar {
    width: 5px !important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: black;
    border-color: 2px solid black;
  }
}
</style>